<div class="loader"></div>
<div class="container-redirect">
    <h5>Ridirecting Please Wait...</h5>
    <a *ngIf="isVisible" [href]="url">Refresh page</a>
</div>